import { FC } from 'react'

import { Word as WordType } from 'models'
import { Container, Dl, Header, Share, Title } from './styled'
import { IconShowMore } from 'components/icons/show-more'
import { useAppContext } from 'context/app-context'

type Props = {
  word: WordType
  onClick: () => void
}

export const Face: FC<Props> = ({ word, onClick }) => {
  const { colors } = useAppContext()

  return (
    <>
      <Container
        onClick={onClick}
        $variant="face"
        $color={
          colors && word?.category in colors
            ? colors[word?.category as keyof typeof colors]
            : ''
        }
      >
        <Share>
          <IconShowMore />
        </Share>

        <Header>
          <span>#{word?.category}</span>
        </Header>

        <Title hyphens={!word.tatar.includes(' ')}>
          <span>
            <span>{word.tatar}</span>
          </span>
        </Title>

        <Dl>
          <dt>english: </dt>
          <dd>{word.english}</dd>
          <dt>Русский: </dt>
          <dd>{word.russian}</dd>
        </Dl>
      </Container>
    </>
  )
}
